// Textos del módulo Reservaciones (reservations.tsx y quick-reservation-modal.tsx).
// Ver src/i18n/textos.ts.
import { defineTextos } from '../textos.ts';

export const textosReservas = defineTextos({
  // Estados (etiqueta visible; el valor del estado no se traduce)
  estadoConfirmada: 'Confirmada',
  estadoPorConfirmar: 'Por confirmar',
  estadoSentada: 'Sentada',
  estadoCancelada: 'Cancelada',
  // Días (chips) y meses
  diaDom: 'DOM', diaLun: 'LUN', diaMar: 'MAR', diaMie: 'MIÉ', diaJue: 'JUE', diaVie: 'VIE', diaSab: 'SÁB',
  mesEnero: 'Enero', mesFebrero: 'Febrero', mesMarzo: 'Marzo', mesAbril: 'Abril',
  mesMayo: 'Mayo', mesJunio: 'Junio', mesJulio: 'Julio', mesAgosto: 'Agosto',
  mesSeptiembre: 'Septiembre', mesOctubre: 'Octubre', mesNoviembre: 'Noviembre', mesDiciembre: 'Diciembre',
  // Mensajes y toasts
  errorCargando: 'Error cargando reservaciones',
  ingresaNombre: 'Ingresa el nombre del cliente',
  seleccionaFechaHora: 'Selecciona fecha y hora',
  reservaCreadaPara: 'Reserva creada para {fecha}',
  noSeGuardo: 'No se pudo guardar la reservación',
  noSeActualizo: 'No se pudo actualizar la reservación',
  noSeSento: 'No se pudo sentar la reservación',
  confirmCancelarTitulo: '¿Cancelar la reserva de {cliente}?',
  confirmCancelarMensaje: 'La reservación queda registrada como cancelada y libera la mesa.',
  cancelarReserva: 'Cancelar reserva',
  volver: 'Volver',
  reservaCancelada: 'Reserva de {cliente} cancelada',
  noSeCancelo: 'No se pudo cancelar',
  // Header y stats
  titulo: 'Reservaciones',
  reservasHoy: 'Reservas hoy',
  personas: 'Personas',
  confirmadas: 'Confirmadas',
  pendientes: 'Pendientes',
  nuevaReserva: 'Nueva reserva',
  todas: 'Todas',
  canceladas: 'Canceladas',
  filtrarPorEstado: 'Filtrar por estado',
  comensales: 'Comensales',
  // Timeline
  cargandoReservaciones: 'Cargando reservaciones…',
  sinReservasDia: 'No hay reservaciones para este día',
  toca: 'Toca',
  paraAgendarUna: 'para agendar una.',
  // Asignar mesa
  asignarMesa: 'Asignar mesa',
  asignarMesaDesc: '{n} pers. — elegí la mesa para sentar y abrir el pedido.',
  mesaAsignadaOcupada: '⚠ La mesa asignada ({mesa}) ya tiene un pedido abierto. Elegí otra mesa para sentar al cliente.',
  elegiMesa: 'Elegí una mesa…',
  capacidadPers: ' ({n} pers.)',
  ocupadaSufijo: ' — ocupada',
  cancelar: 'Cancelar',
  sentarYAbrir: 'Sentar y abrir pedido',
  // Carril de meses
  mesAnterior: 'Mes anterior',
  mesSiguiente: 'Mes siguiente',
  hoy: 'Hoy',
  nRes: '{n} res.',
  hoyMin: 'hoy',
  // Tarjeta de reserva
  pers: 'pers.',
  confirmar: 'Confirmar',
  marcarSentada: 'Marcar sentada',
  // Panel nueva reserva
  seleccionaFecha: 'Selecciona una fecha',
  cerrar: 'Cerrar',
  cliente: 'Cliente',
  nombreApellido: 'Nombre y apellido',
  telefono: 'Teléfono',
  fecha: 'Fecha',
  hora: 'Hora',
  otraHora: '¿Otra hora?',
  mesaZona: 'Mesa / zona',
  sinAsignar: 'Sin asignar',
  aptasPara: '✓ Aptas para {n} pers.',
  exacta: ' · exacta',
  sobra: ' · sobra {n}',
  mesasPequenas: 'Mesas más pequeñas (requieren juntar)',
  faltaOpcion: '({cap}p · falta {n})',
  ocasion: 'Ocasión',
  ninguna: 'Ninguna',
  ocasionCumpleanos: 'Cumpleaños',
  ocasionAniversario: 'Aniversario',
  ocasionNegocios: 'Negocios',
  ocasionCelebracion: 'Celebración',
  notas: 'Notas',
  notasPlaceholder: 'Alergias, silla para bebé, mesa junto a la ventana…',
  estado: 'Estado',
  guardando: 'Guardando…',
  guardarReserva: 'Guardar reserva',
  opcional: 'opcional',
  menosPersonas: 'Menos personas',
  masPersonas: 'Más personas',
  // Reserva rápida (quick-reservation-modal.tsx)
  qrReservaConfirmada: 'Reserva {id} confirmada',
  qrToastDescripcion: '{cliente} · {ciudad} Mesa {mesa} · {fecha} {hora} · {personas} pers.',
  qrSedeFallback: 'sede',
  qrInfoCliente: 'Información del Cliente',
  qrSedeLabel: 'Sede:',
  qrNombreCliente: 'Nombre del Cliente',
  qrNombreCompleto: 'Nombre completo',
  qrCantidadPersonas: 'Cantidad de Personas',
  qrEj4: 'Ej: 4',
  qrContinuar: 'Continuar',
  qrFechaHoraReserva: 'Fecha y Hora de la Reserva',
  qrAtras: 'Atrás',
  qrMotivoYMesa: 'Motivo y Mesa',
  qrMotivoOpcional: 'Motivo de la Reserva (Opcional)',
  qrMotivoPlaceholder: 'Ej: Cumpleaños, Cena de negocios...',
  qrSeleccionaMesa: 'Selecciona una Mesa',
  qrMesasSugeridas: 'Mesas sugeridas para {n} personas:',
  qrMesa: 'Mesa',
  qrPuestos: 'puestos',
  qrSinMesas: 'No hay mesas disponibles para {n} personas.',
  qrOtraCantidad: 'Por favor, selecciona otra cantidad o fecha.',
  qrMesaPreseleccionada: 'Mesa Preseleccionada:',
  qrVerResumen: 'Ver Resumen',
  qrResumen: 'Resumen de la Reserva',
  qrSede: 'Sede',
  qrPersonas: 'personas',
  qrFechaYHora: 'Fecha y Hora',
  qrMesaAsignada: 'Mesa Asignada',
  qrMotivo: 'Motivo',
  qrAvisoConfirmacion: 'La reserva se confirmará y la mesa permanecerá disponible hasta la hora indicada',
  qrConfirmarReserva: 'Confirmar Reserva',
}, {
  estadoConfirmada: 'Confirmed',
  estadoPorConfirmar: 'Unconfirmed',
  estadoSentada: 'Seated',
  estadoCancelada: 'Cancelled',
  diaDom: 'SUN', diaLun: 'MON', diaMar: 'TUE', diaMie: 'WED', diaJue: 'THU', diaVie: 'FRI', diaSab: 'SAT',
  mesEnero: 'January', mesFebrero: 'February', mesMarzo: 'March', mesAbril: 'April',
  mesMayo: 'May', mesJunio: 'June', mesJulio: 'July', mesAgosto: 'August',
  mesSeptiembre: 'September', mesOctubre: 'October', mesNoviembre: 'November', mesDiciembre: 'December',
  errorCargando: 'Error loading reservations',
  ingresaNombre: "Enter the customer's name",
  seleccionaFechaHora: 'Select a date and time',
  reservaCreadaPara: 'Reservation created for {fecha}',
  noSeGuardo: 'Could not save the reservation',
  noSeActualizo: 'Could not update the reservation',
  noSeSento: 'Could not seat the reservation',
  confirmCancelarTitulo: 'Cancel the reservation for {cliente}?',
  confirmCancelarMensaje: 'The reservation is recorded as cancelled and the table is released.',
  cancelarReserva: 'Cancel reservation',
  volver: 'Back',
  reservaCancelada: 'Reservation for {cliente} cancelled',
  noSeCancelo: 'Could not cancel',
  titulo: 'Reservations',
  reservasHoy: 'Reservations today',
  personas: 'People',
  confirmadas: 'Confirmed',
  pendientes: 'Pending',
  nuevaReserva: 'New reservation',
  todas: 'All',
  canceladas: 'Cancelled',
  filtrarPorEstado: 'Filter by status',
  comensales: 'Guests',
  cargandoReservaciones: 'Loading reservations…',
  sinReservasDia: 'No reservations for this day',
  toca: 'Tap',
  paraAgendarUna: 'to book one.',
  asignarMesa: 'Assign table',
  asignarMesaDesc: '{n} ppl. Pick the table to seat them and open the order.',
  mesaAsignadaOcupada: '⚠ The assigned table ({mesa}) already has an open order. Pick another table to seat the customer.',
  elegiMesa: 'Pick a table…',
  capacidadPers: ' ({n} ppl)',
  ocupadaSufijo: ' · occupied',
  cancelar: 'Cancel',
  sentarYAbrir: 'Seat and open order',
  mesAnterior: 'Previous month',
  mesSiguiente: 'Next month',
  hoy: 'Today',
  nRes: '{n} res.',
  hoyMin: 'today',
  pers: 'ppl',
  confirmar: 'Confirm',
  marcarSentada: 'Mark as seated',
  seleccionaFecha: 'Select a date',
  cerrar: 'Close',
  cliente: 'Customer',
  nombreApellido: 'First and last name',
  telefono: 'Phone',
  fecha: 'Date',
  hora: 'Time',
  otraHora: 'Another time?',
  mesaZona: 'Table / area',
  sinAsignar: 'Unassigned',
  aptasPara: '✓ Fits {n} ppl',
  exacta: ' · exact fit',
  sobra: ' · {n} extra',
  mesasPequenas: 'Smaller tables (need to be joined)',
  faltaOpcion: '({cap}p · {n} short)',
  ocasion: 'Occasion',
  ninguna: 'None',
  ocasionCumpleanos: 'Birthday',
  ocasionAniversario: 'Anniversary',
  ocasionNegocios: 'Business',
  ocasionCelebracion: 'Celebration',
  notas: 'Notes',
  notasPlaceholder: 'Allergies, high chair, table by the window…',
  estado: 'Status',
  guardando: 'Saving…',
  guardarReserva: 'Save reservation',
  opcional: 'optional',
  menosPersonas: 'Fewer people',
  masPersonas: 'More people',
  qrReservaConfirmada: 'Reservation {id} confirmed',
  qrToastDescripcion: '{cliente} · {ciudad} Table {mesa} · {fecha} {hora} · {personas} ppl',
  qrSedeFallback: 'branch',
  qrInfoCliente: 'Customer information',
  qrSedeLabel: 'Branch:',
  qrNombreCliente: 'Customer name',
  qrNombreCompleto: 'Full name',
  qrCantidadPersonas: 'Number of people',
  qrEj4: 'E.g. 4',
  qrContinuar: 'Continue',
  qrFechaHoraReserva: 'Reservation date and time',
  qrAtras: 'Back',
  qrMotivoYMesa: 'Reason and table',
  qrMotivoOpcional: 'Reservation reason (optional)',
  qrMotivoPlaceholder: 'E.g. Birthday, business dinner...',
  qrSeleccionaMesa: 'Select a table',
  qrMesasSugeridas: 'Suggested tables for {n} people:',
  qrMesa: 'Table',
  qrPuestos: 'seats',
  qrSinMesas: 'No tables available for {n} people.',
  qrOtraCantidad: 'Please choose another party size or date.',
  qrMesaPreseleccionada: 'Preselected table:',
  qrVerResumen: 'View summary',
  qrResumen: 'Reservation summary',
  qrSede: 'Branch',
  qrPersonas: 'people',
  qrFechaYHora: 'Date and time',
  qrMesaAsignada: 'Assigned table',
  qrMotivo: 'Reason',
  qrAvisoConfirmacion: 'The reservation will be confirmed and the table will stay available until the set time',
  qrConfirmarReserva: 'Confirm reservation',
});
